var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 17.25,
    height: 17.25,
    rx: 8.625,
    stroke: "#F26F6F",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L12 12",
    stroke: "#F26F6F",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6L6.00091 11.9991",
    stroke: "#F26F6F",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedCircleIcon);
export default __webpack_public_path__ + "static/media/crossRedCircleIcon.6cc85cfb91450049e1d1c2d007fd9d23.svg";
export { ForwardRef as ReactComponent };